import { getRequest } from "../../shared/api/axiosHandler";

export const fetchHotdeals = async (page = 0, size = 18) => {
  try {
    const response = await getRequest(`/public/products/hot-deals?page=${page}&size=${size}`);
    return response; 
  } catch (error) {
    throw error;
  }
}

export const getAllCollections = async (page = 0) => {
  try {
    return await getRequest(`/public/collections?page=${page}`);
  } catch (error) {
    throw error;
  }
};

export const getCollectionById = async (slug,page=0,size=20) => {
  try {
    return await getRequest(`/public/collections/${slug}?page=${page}&size=${size}`);
  } catch (error) {
    throw error;
  }
};

export const fetchProductsByCollectionId = async (collectionId, page = 0, size = 30) => {
  try {
    const response = await getRequest(`/public/collections/id/${collectionId}?page=${page}&size=${size}`);
    return response;
  } catch (error) {
    throw error;
  }
};
